import {Component, AfterViewInit, ViewChild} from '@angular/core';
import {MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteTrigger as MatAutocompleteTrigger} from '@angular/material/legacy-autocomplete';
import {MatLegacyButton as MatButton} from '@angular/material/legacy-button';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {MatLegacyInput as MatInput} from '@angular/material/legacy-input';
import {MatSort} from '@angular/material/sort';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {IdexService} from 'app/idex.service';
import {Toast} from 'app/shared/toast/toast';
import {SelectionModel} from '@angular/cdk/collections';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {TranslateService} from '@ngx-translate/core';
import {NewContactComponent} from './new-contact/new-contact.component';
import {merge, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {PaginatorComponent} from '../../shared/paginator/paginator.component';
import {ShareComponent} from '../share/share.component';

@Component({
   selector: 'app-contact',
   templateUrl: './contact.component.html',
   styleUrls: ['./contact.component.css']
})

export class ContactComponent implements AfterViewInit {
   isLoadingResults = true;
   isLoadingResultsShare = true;
   isRateLimitReached = false;
   isRateLimitReachedShare = false;
   showTabShare = false;
   resultsLength = 0;
   resultsLengthShare = 0;
   errorMessage: string;
   contactType: string;
   selectTabIndex = 0;
   selectedRowIndex = -1;
   selectedRowIndexShare = -1;
   isAddContact = true;
   clickActive: boolean;

   displayedColumns = ['select', 'no', 'contact_name', 'contact_email', 'active', 'menu'];
   displayedColumnsShare = [ 'no', 'contact_name', 'contact_email' , 'create_by'];

   dataSource: MatTableDataSource<UserData>;
   selection = new SelectionModel<UserData>(true, []);
   users: UserData[] = [];
   userShare: UserData[] = [];
   error_email = false;
   filterContactValue: any;
   filterContactValueShare: any;
   pageSize = 50;
   pageSizeShare = 50;

   dataSourceShare: MatTableDataSource<UserData>;
   selectionShare = new SelectionModel<UserData>(true, []);
   groups: UserData[];
   searching: any;
   searchingShare: any;
   searchFocused: boolean;
   searchFocusedShare: boolean;
   preventBlur: boolean;
   preventBlurShare: boolean;
   searchResult: any[];
   searchResultShare: any[];
   searchvalue: any;
   searchvalueShare: any;
   private timer: any;

   @ViewChild('txtContactId') public txtContId: MatInput;
   @ViewChild('fullName') public txtFullName;
   @ViewChild('groupName') public txtGroupName;
   @ViewChild('email') public txtEmail: MatInput;
   @ViewChild('btnDelContact') public buttonDel: MatButton;
   @ViewChild(PaginatorComponent, {static: true}) paginator: PaginatorComponent;
   @ViewChild(PaginatorComponent, {static: true}) paginatorShare: PaginatorComponent;
   @ViewChild('sortMe') sort: MatSort;
   @ViewChild('sortShare') sortShare: MatSort;
   @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete;
   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;

   @ViewChild(MatAutocompleteTrigger)
   private trigger: MatAutocompleteTrigger;

   private contactDialog: MatDialogRef<NewContactComponent>;
   private share: MatDialogRef<ShareComponent>;

   constructor(public service: IdexService,
               public toast: Toast,
               public dialog: MatDialog,
               private translate: TranslateService) {
   }

   ngAfterViewInit() {
      setTimeout(() => {
         this.clickActive = false;
         this.contactType = 'C';
         this.buttonDel.disabled = true;

         this.getContactList();
         this.getContactListShare();
      }, 0);
   }

   highlight(row) {
      if (!this.clickActive) {
         this.contactDialog = this.dialog.open(NewContactComponent, {
            disableClose: true,
            data: this,
            width: '450px'
         });
         this.contactDialog.componentInstance.isAddContact = false;
         this.contactDialog.componentInstance.contIdvalue = row.contactId;
         this.contactDialog.componentInstance.contNamevalue = row.fullName;
         this.contactDialog.componentInstance.contEmailvalue = row.email;

         this.contactDialog.afterClosed().subscribe(result => {
            if (result) {
               this.getContactList();
               this.getContactListShare();
            }
         });
         this.selectedRowIndex = row.no;
      }
      this.clickActive = false;
   }

   highlightShare(row) {
      if (!this.clickActive) {
         this.contactDialog = this.dialog.open(NewContactComponent, {
            disableClose: true,
            data: this,
            width: '450px'
         });
         this.contactDialog.componentInstance.isAddContact = false;
         this.contactDialog.componentInstance.contIdvalue = row.contactId;
         this.contactDialog.componentInstance.contNamevalue = row.fullName;
         this.contactDialog.componentInstance.contEmailvalue = row.email;
         this.contactDialog.componentInstance.viewMode = true;

         this.contactDialog.afterClosed().subscribe(result => {
            if (result) {
               this.getContactList();
               this.getContactListShare();
            }
         });
         this.selectedRowIndexShare = row.no;
      }
      this.clickActive = false;
   }

   LoadGroupTabs(event) {
      const indexSelected = event.index;
      if (indexSelected === 0) {
         this.contactType = 'C';
      } else if (indexSelected === 1) {
         this.contactType = 'G';
      }
      setTimeout(() => {
         if (this.selectTabIndex === 0) {
            this.searching = '';
            this.filterContactValue = '';
            this.getContactList();
         }
         if (this.selectTabIndex === 1) {
            this.searchingShare = '';
            this.filterContactValueShare = '';
            this.getContactListShare();
         }
      }, 100);
      this.selection.clear();
      this.selectionShare.clear();
      this.buttonDel.disabled = true;
   }

   getContactList() {
      this.loader.show();

      merge(this.paginator.page)
         .pipe(
            startWith({}),
            switchMap(() => {
               this.isLoadingResults = true;
               if (this.paginator.size !== undefined) {
                  this.pageSize = this.paginator.size;
               }

               if (this.filterContactValue === undefined) {
                  this.filterContactValue = '';
               }

               let sort = 'contact_name';
               let order = 'asc';
               if (this.sort) {
                  sort = this.sort.active;
                  order = this.sort.direction;
               }

               return this.service.getContactAll(
                  this.pageSize, this.paginator.page, sort, order, encodeURIComponent(this.filterContactValue), 'f');
            }),
            map(data => {
               // Flip flag to show that loading has finished.
               this.isLoadingResults = false;
               this.isRateLimitReached = false;
               this.selectedRowIndex = -1;
               this.selection.clear();
               this.buttonDel.disabled = true;
               this.resultsLength = data.totalCount;
               this.users = data.items;
               this.dataSource = new MatTableDataSource(this.users);
               if (this.paginator.page !== data.pageIndex) {
                  this.paginator.page = data.pageIndex;
               }

               this.loader.hide();
               return data.items;
            }),
            catchError(() => {
               this.isLoadingResults = false;
               // Catch if the GitHub API has reached its rate limit. Return empty data.
               this.isRateLimitReached = true;
               this.loader.hide();
               return observableOf([]);
            })
         ).subscribe(data => this.dataSource.data = data);
   }

   getContactListShare() {
      this.loader.show();

      merge(this.paginatorShare.page)
         .pipe(
            startWith({}),
            switchMap(() => {
               this.isLoadingResultsShare = true;
               if (this.paginatorShare.size !== undefined) {
                  this.pageSizeShare = this.paginatorShare.size;
               }

               if (this.filterContactValueShare === undefined) {
                  this.filterContactValueShare = '';
               }

               let sort = 'contact_name';
               let order = 'asc';
               if (this.sortShare) {
                  sort = this.sortShare.active;
                  order = this.sortShare.direction;
               }

               return this.service.getContactAllShare(
                  this.pageSizeShare, this.paginatorShare.page, sort, order, encodeURIComponent(this.filterContactValueShare), 'f');
            }),
            map(data => {
               // Flip flag to show that loading has finished.
               this.isLoadingResultsShare = false;
               this.isRateLimitReachedShare = false;
               this.selectedRowIndexShare = -1;
               this.selection.clear();
               this.buttonDel.disabled = true;
               this.resultsLengthShare = data.totalCount;
               this.userShare = data.items;
               if (this.userShare.length !== 0) {
                  this.showTabShare = true;
               }
               this.dataSourceShare = new MatTableDataSource(this.userShare);
               if (this.paginatorShare.page !== data.pageIndex) {
                  this.paginatorShare.page = data.pageIndex;
               }

               this.loader.hide();
               return data.items;
            }),
            catchError(() => {
               this.isLoadingResultsShare = false;
               // Catch if the GitHub API has reached its rate limit. Return empty data.
               this.isRateLimitReachedShare = true;
               this.loader.hide();
               return observableOf([]);
            })
         ).subscribe(data => this.dataSourceShare.data = data);
   }

   onSearch(input: any, filterValue: string) {
      this.searchFocused = false;
      this.searchvalue = filterValue;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const value = filterValue.trim();
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(value)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         filterValue = filterValue.trim(); // Remove whitespace
         filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
         this.filterContactValue = filterValue;
         this.getContactList();
         input.blur();
      }
   }

   onSearchShare(input: any, filterValue: string) {
      this.searchFocusedShare = false;
      this.searchvalueShare = filterValue;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const value = filterValue.trim();
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(value)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         filterValue = filterValue.trim(); // Remove whitespace
         filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
         this.filterContactValueShare = filterValue;
         this.getContactListShare();
         input.blur();
      }
   }

   onSearchChange(input: any, e: any) {
      if (e.keyCode !== 13) {
         this.searchFocused = true;
      }

      this.searchResult = null;
      this.searchChange(input);
   }

   onSearchChangeShare(input: any, e: any) {
      if (e.keyCode !== 13) {
         this.searchFocusedShare = true;
      }

      this.searchResultShare = null;
      this.searchChangeShare(input);
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   onSearchBlurShare() {
      setTimeout(() => {
         if (!this.preventBlurShare) {
            this.searchFocusedShare = false;
         }
      }, 300);
   }

   onSearchFocus(input: any) {
      this.searchFocused = true;
      this.searchChange(input);
   }

   onSearchFocusShare(input: any) {
      this.searchFocusedShare = true;
      this.searchChangeShare(input);
   }

   searchChange(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const kw = encodeURIComponent(input.value.trim());
      if (kw.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.service.getContactAll(0, 0, '',
            '', kw, 't')
            .subscribe(
               data => {
                  if (this.timer == null) {
                     this.searchResult = data;
                  }
               });
      }, 300);
   }

   searchChangeShare(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const kw = encodeURIComponent(input.value.trim());
      if (kw.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.service.getContactAllShare(0, 0, '',
            '', kw, 't')
            .subscribe(
               data => {
                  if (this.timer == null) {
                     this.searchResultShare = data;
                  }
               });
      }, 300);
   }

   activeContact(id: any, email: any, active: any , row: any) {
      this.clickActive = true;
      const contactId = id.innerHTML;
      const contactEmail = email.innerHTML;
      const activeFlg = active.checked;
      if (activeFlg === false) {
         this.service.activeContact(contactId, contactEmail)
            .subscribe((response) => {
               this.toast.success(response);
               this.getContactList();
            });
      } else {
         this.service.inactiveContact(contactId, contactEmail)
            .subscribe((response) => {
               this.toast.warn(response);
               if (row.shareId !== 0) {
                  this.service.unshare(row.contactId, 'CT')
                     .subscribe(
                        () => {
                           this.getContactList();
                        },
                        error => {
                           this.errorMessage = error;
                        });
               } else {
                  this.getContactList();
               }
            });
      }
   }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelected() {
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;

      if (numSelected > 0) {
         this.buttonDel.disabled = false;
      } else {
         this.buttonDel.disabled = true;
      }
      return numSelected === numRows;
   }

   /** Selects all rows if they are not all selected; otherwise clear selection. */
   masterToggle() {
      if (this.isAllSelected()) {
         this.selection.clear();
         this.buttonDel.disabled = true;
      } else {
         this.dataSource.data.forEach(row => this.selection.select(row));
         this.buttonDel.disabled = false;
      }
   }

   disableButton(row: any) {
      if (this.contactType === 'C') {
         const numSelected = this.selection.selected.length;
         if (numSelected > 0) {
            this.buttonDel.disabled = false;
         } else {
            this.buttonDel.disabled = true;
         }
         return this.selection.isSelected(row);
      } else {
         return false;
      }
   }

   openContractDialog() {
      this.contactDialog = this.dialog.open(NewContactComponent, {
         disableClose: true,
         data: this,
         width: '450px'
      });
      this.contactDialog.componentInstance.contIdvalue = '';
      this.contactDialog.componentInstance.contNamevalue = '';
      this.contactDialog.componentInstance.contEmailvalue = '';
      this.contactDialog.componentInstance.error_email = false;
      this.contactDialog.afterClosed().subscribe(result => {
         if (result) {
            this.getContactList();
         }
      });
      this.selectTabIndex = 0;
   }

   deleteContact() {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('main.manage-contact').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const IdList: number[] = [];
            for (let i = 0; i < this.selection.selected.length; i++) {
               IdList.push(this.selection.selected[i].contactId);
            }
            this.service.deleteContact(IdList)
               .subscribe((response) => {
                  this.toast.success(response);
                  this.selection.clear();

                  this.getContactList();
               });
         }
      });
   }

   tabShare(row) {
      if (row.shareId !== 0) {
         this.service.getAllShare(row.shareId)
            .subscribe((data: any) => {
               this.share.componentInstance.shareGroup = data.group;
               this.share.componentInstance.shareUser = data.contact;
               this.share.componentInstance.shareSites = data.sites;
               this.share.componentInstance.membersShare = data.UserShares;
               this.share.componentInstance.groupShare = data.GroupShare;
               this.share.componentInstance.siteShare = data.SiteShares;
            }, error => {
               this.errorMessage = error;
            });
      }
      if (!this.clickActive) {
         this.share = this.dialog.open(ShareComponent, {
            disableClose: true,
            data: this,
            width: '600px'
         });
         this.share.componentInstance.objectId = row.contactId;
         this.share.componentInstance.shareId = row.shareId;
         this.share.componentInstance.objectType = 'CT';
         this.share.componentInstance.contactId = row.contactId;
         this.share.afterClosed().subscribe(result => {
            this.getContactList();
            this.getContactListShare();
         });
      }
      this.clickActive = false;
   }

}


export interface UserData {
   no: number;
   contactId: number;
   fullName: string;
   email: string;
   active: boolean;
   shareId: any;
}
